import { Body, Flex } from '@cognite/cogs.js-v10';

import * as S from '../elements';

type LegacySaveButtonProps = {
  onClick: () => Promise<void>;
  disabled: boolean;
  loading: boolean;
  hasButtonHelpText?: boolean;
};

export const LegacySaveButton = ({
  onClick,
  disabled,
  loading,
  hasButtonHelpText = false,
}: LegacySaveButtonProps) => {
  return (
    <Flex direction="column" gap={4}>
      <S.FixedWidthButton
        onClick={onClick}
        disabled={disabled}
        loading={loading}
      >
        Save configuration
      </S.FixedWidthButton>
      {hasButtonHelpText && (
        <Body size="x-small">Saving configuration will reload the app</Body>
      )}
    </Flex>
  );
};
